/**
 * Single source of truth for the store-credit / "shop again" mechanism.
 * Zero-import leaf. (`redo/settings/common` keeps a labelled copy on purpose.)
 */
export const shopAgainActions = [
  "gift_card",
  "discount_code",
  "rise",
  "loopz",
  "creditsyard",
  "bubblehouse",
  "shopify_account",
  "gift_card_order",
  "noop",
] as const;

export type ShopAgainAction = (typeof shopAgainActions)[number];
export const ShopAgainAction = shopAgainActions;
